import _classCallCheck from '../../../@babel/runtime/helpers/esm/classCallCheck.js';
import _createClass from '../../../@babel/runtime/helpers/esm/createClass.js';

/**
 * Cache class that allows to search in a cache hierarchy.
 * @template T, Q
 */
var Cache = /*#__PURE__*/function () {
  /**
   * Creates a Cache instance
   * @param {Cache} [parent]
   */
  function Cache(parent) {
    _classCallCheck(this, Cache);
    this._parent = parent;
    this._cache = new Map();
  }

  /**
   * Returns a boolean indicating whether an element with the specified key exists or not.
   *
   * @param {T} key - The key of the element to test for presence in the Cache object.
   * @return {boolean}
   */
  _createClass(Cache, [{
    key: "has",
    value: function has(key) {
      return !!(this._cache.has(key) || this._parent && this._parent._cache.has(key));
    }

    /**
     * Adds or updates an element with a specified key and a value to a Cache object.
     *
     * @param {T} key - The key of the element to add to the Cache object.
     * @param {Q} value - The value of the element to add to the Cache object.
     * @return {Cache<T, Q>} the cache object
     */
  }, {
    key: "set",
    value: function set(key, value) {
      this._cache.set(key, value);
      return this;
    }

    /**
     * Returns a specified element from a Map object. If the value that is associated to the provided key is an
     * object, then you will get a reference to that object and any change made to that object will effectively modify
     * it inside the Map object.
     *
     * @param {T} key - The key of the element to return from the Cache object.
     * @return {Q}
     */
  }, {
    key: "get",
    value: function get(key) {
      return this._cache.get(key) || this._parent && this._parent._cache.get(key);
    }
  }]);
  return Cache;
}();

export { Cache };
